module.exports = __webpack_public_path__ + "static/img/slogn-en.d8004c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/slogn/slogn-en.png
// module id = FpEj
// module chunks = 1